import { createStore, applyMiddleware } from 'redux';
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import reducers from './reducers/reducers';

import rootSaga from './sagas/sagas';

const sagaMiddleware = createSagaMiddleware();

export default function buildStore(history) {
  const store = createStore(reducers, composeWithDevTools(applyMiddleware(sagaMiddleware, routerMiddleware(history))));

  // Hot reloading
  if (module.hot) {
    module.hot.accept('./reducers/reducers', () => {
      store.replaceReducer(reducers);
    });
    module.hot.accept('./sagas/sagas', () => {
      store.replaceReducer(reducers);
    });
  }

  sagaMiddleware.run(rootSaga);

  const syncedHistory = syncHistoryWithStore(history, store);

  return {
    syncedHistory,
    store
  };
}



// WEBPACK FOOTER //
// ./src/app/store.js